<template>
  <div
    class="event-list-search"
    :class="{ 'event-list-search--advanced': search.advanced }"
  >
    <div v-if="!search.advanced">
      <div class="row">
        <div class="col-md-9">
          <InputControl
            id="query"
            v-model="search.query"
            label=""
            placeholder="Szukaj w treści..."
            :inline="false"
          />
        </div>
        <div class="col-md-3">
          <SelectControl
            id="certificationStatus"
            v-model="search.status"
            :get-object="false"
            :options="certificationStatusType"
          />
        </div>
      </div>
    </div>

    <div v-if="search.advanced">
      <div class="row">
        <div class="col-md-6">
          <InputControl
            id="query"
            v-model="search.query"
            label="Szukaj w treści"
            :inline="false"
          />
        </div>
        <div class="col-md-3">
          <DateControl
            id="dateStart"
            v-model="search.dateStart"
            min-date="2021-03-01"
            label="Data początkowa wydarzenia"
            :inline="false"
          />
        </div>
        <div class="col-md-3">
          <DateControl
            id="dateEnd"
            v-model="search.dateEnd"
            label="Data końcowa wydarzenia"
            :inline="false"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <OrganizationTypeAheadControl
            id="organization-name"
            v-model="search.organizationName"
            label="Organizator"
            :min-length="2"
            :select-first="false"
          />
        </div>
        <div class="col-md-6">
          <InputControl
            id="organization-name"
            v-model="search.city"
            label="Miejscowość"
            :min-length="2"
            :select-first="false"
          />
        </div>
        <div class="col-md-3">
          <SelectControl
            id="status"
            v-model="search.eventType"
            label="Rodzaj wydarzenia"
            :get-object="false"
            :options="eventType"
          />
        </div>
        <div class="col-md-3">
          <SelectControl
            id="status"
            v-model="search.eventArea"
            label="Obszar wydarzenia"
            :get-object="false"
            :options="eventAreaType"
          />
        </div>
        <!-- <div class="col-md-3">
          <SelectControl
            id="status"
            v-model="search.status"
            label="Status"
            :get-object="false"
            :options="statusType"
          />
        </div> -->
        <div class="col-md-6">
          <SelectControl
            id="certificationStatus"
            v-model="search.status"
            label="Wynik Oceny"
            :get-object="false"
            :options="certificationStatusType"
          />
        </div>
      </div>
    </div>

    <footer>
      <div class="row">
        <div class="col-md-6">
          <div class="event-list-search__found">
            Znaleziono: {{ total }} (
            <a href="" @click.prevent="reset"> Reset filtrów </a>)
          </div>
        </div>
        <div class="col-md-6 text-right">
          <Btn
            v-if="listType == 'grid'"
            icon="table"
            variant="link"
            tooltip="Wyświetl jako tabelę"
            @click.prevent="setListType('table')"
          ></Btn>
          <Btn
            v-if="listType == 'table'"
            icon="apps"
            variant="link"
            tooltip="Wyświetl jako siatkę"
            @click.prevent="setListType('grid')"
          ></Btn>
          <Btn
            v-if="!search.advanced"
            variant="link"
            @click.prevent="search.advanced = !search.advanced"
            >Wyszukiwanie zaawansowane</Btn
          >
          <Btn
            v-if="search.advanced"
            variant="link"
            @click.prevent="search.advanced = !search.advanced"
            >Wyszukiwanie uproszczone</Btn
          >
          <Loading v-model="loading" />
          &nbsp;
          <Btn variant="outline-primary" :href="exportUrl" target="_blank">
            Eksport
          </Btn>
          &nbsp;
          <Btn variant="primary" @click="submitSearch">
            Szukaj
          </Btn>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import PublicEventSearch from "./PublicEventSearch";

export default {
  name: "UserEventSearch",
  extends: PublicEventSearch
};
</script>
